/**
 * Returns the largest element in an array
 */
export default function max(target) {
  return Math.max.apply(0, target);
}
